import { render, staticRenderFns } from "./AssinarPEP.vue?vue&type=template&id=4dbcbfba&"
import script from "./AssinarPEP.vue?vue&type=script&lang=js&"
export * from "./AssinarPEP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports